import React, { useEffect, useState, useRef } from "react";
import { Upload, Flex, Radio, notification, InputNumber, Select } from "antd";
import {
  InboxOutlined,
  InfoCircleOutlined,
  CheckCircleOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import "react-quill/dist/quill.snow.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import imageCompression from "browser-image-compression";
import { addEditData } from "../../controllers/admissionProcess/admissionProcess";
import { fetchIpAddress } from "../../controllers/API";

import LoadingEffect from "../../components/Loading/LoadingEffect";
import { beforeUpload, beforeUploadPDF } from "../../controllers/common";

const UserListEditPage = () => {
  const { Option } = Select;
  const { Dragger } = Upload;
  const targetRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;
  const [error, setError] = useState([]);
  const [ADDEDITDATA, setAddEditSata] = useState(state ? state : []);
  const [file, setFile] = useState([]);
  const [image, setImage] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  /*********************************************************
   *  This function is use to handle imput chnage
   *********************************************************/
  const handleChange = (e) => {
    setAddEditSata((pre) => ({
      ...pre,
      [e.target.name]: e.target.value,
    }));
    setError((pre) => ({
      ...pre,
      [e.target.name]: "",
    }));
  };

  /*********************************************************
   *  This function is used to handle image upload and compression
   *********************************************************/
   /*********************************************************
   *  This function is used to handle image upload and compression
   *********************************************************/
   const handleImageChange = async (info) => {
    const file = info.file.originFileObj || info.file;

    if (info.file.status === "removed") {
      return; // Ignore remove events
    }
    // Validate file type and size
    if (!file.type.startsWith("image/")) {
      setError((prev) => ({ ...prev, image: "Please upload a valid image file." }));
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      setError((prev) => ({ ...prev, image: "Image must be smaller than 5MB." }));
      return;
    }

    // Compress the image
    const options = {
      maxSizeMB: 1, // Maximum size in MB after compression
      maxWidthOrHeight: 1024, // Maximum width or height
      useWebWorker: true, // Use web worker for better performance
    };

    try {
      const compressedFile = await imageCompression(file, options);
      const newFile = {
        ...file,
        originFileObj: compressedFile, // Replace the original file with the compressed one
      };
      setImage((prev) => [...prev, newFile]);
      setError((prev) => ({ ...prev, image: "" }));
    } catch (error) {
      console.error("Error compressing image:", error);
      setError((prev) => ({ ...prev, image: "Failed to compress image." }));
    }
  };
  const handleRemove = (file) => {
    setImage((prev) => prev.filter((img) => img.uid !== file.uid)); // Remove specific image
  };

  /*********************************************************
   *  This function is use to handle form submit
   *********************************************************/
  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    try {
      const {
        _id,
        title,
        sub_title,
        content,
        btntext,
        btnlink
      } = ADDEDITDATA;
      const ipAddress = (await fetchIpAddress()) || "0.0.0.0";

      const form = new FormData();
      if (_id && _id !== "undefined" && _id !== null) {
        form.append("edit_id", _id);
      }
      if (image) {
        image.forEach((item, index) => {
          form.append(`image`, item.originFileObj);
        });
      }
      form.append("title", title ? title : '');
      form.append("sub_title", sub_title ? sub_title : '');
      form.append("content", content ? content : '');
      form.append("btntext", btntext ? btntext : '');
      form.append("btnlink", btnlink ? btnlink : '');
      form.append("ipAddress", ipAddress);

      const isValidate = validateFormData(form);
      if (isValidate) {
        const options = {
          url: `admissionProcess/addeditdata/${_id ? _id : ':editId'}`,
          postData: form,
        };
        const res = await addEditData(options);
        if (res.status === true) {
          const actionMessage = _id ? "updated" : "added";
          notification.open({
            message: `Data ${actionMessage}.`,
            description: `Data ${actionMessage} successfully.`,
            placement: "topRight",
            icon: <CheckCircleOutlined style={{ color: "green" }} />,
            duration: 2,
          });
          navigate("/admission-process");
        } else {
          notification.open({
            message: "Opps!",
            description: `${res?.message}`,
            placement: "topRight",
            icon: <InfoCircleOutlined style={{ color: "red" }} />,
            duration: 2,
          });
        }
      } else {
        notification.open({
          message: "Opps!",
          description: `Please enter the required fields.`,
          placement: "topRight",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
        });
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setIsLoading(false);
    }
  };


  const validateFormData = (form) => {
    if (!form.get("title").trim() || form.get("title").trim() === "undefined" || form.get("title").trim() === null) {
      setError((preError) => ({
        ...preError,
        title: "Title is required",
      }));
      return false;
    }
    if (!form.get("sub_title").trim() || form.get("sub_title").trim() === "undefined" || form.get("sub_title").trim() === null) {
      setError((preError) => ({
        ...preError,
        sub_title: "Sub-Title is required",
      }));
      return false;
    }
    if (!form.get("content").trim() || form.get("content").trim() === "undefined" || form.get("content").trim() === null) {
      setError((preError) => ({
        ...preError,
        content: "Content is required",
      }));
      return false;
    }
    return true;
  };




  useEffect(() => {
    targetRef.current.scrollIntoView({
      behavior: 'smooth',
    });
    document.title = `KC High Super Admin || ${ADDEDITDATA?._id ? "Edit" : "Add"
      } Admission Process`;
  }, [ADDEDITDATA]);

  return (
    <div ref={targetRef}>
      {" "}
      <div className="container-fluid">
        <div className="Inventory_edit_page_main_div">
          <div>
            <h5 className="inventory_edit_page_heading">
              {ADDEDITDATA?._id ? `Edit` : `Add`} Admission Process
            </h5>
          </div>
          <Link to="/admission-process">
            <div>
              <button type="button" className="btn btn-secondary">
                <ArrowLeftOutlined /> Back
              </button>
            </div>
          </Link>
        </div>

        <div className="card shadow mb-4 dataBase_table_Add_Data">
          <div className="card-body">
            <div className="responsive">
              <form method="post" className="inventory_form_main_contnet">
                <div className="row">
                  <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="title"
                      className="all_section_for_label_main_class"
                    >
                      <span style={{ color: "red" }}>*</span>Title :{" "}
                    </label>
                    <input
                      title="Enter title"
                      placeholder="Enter title"
                      type="text"
                      name="title"
                      className="form-control store_input_field"
                      id="title"
                      value={ADDEDITDATA?.title}
                      onChange={handleChange}
                    />
                    {error.title ? (
                      <p style={{ color: "red" }}>
                        {error.title}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="sub_title"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Subtitle :{" "}
                    </label>
                    <input
                      title="Enter subtitle"
                      placeholder="Enter subtitle"
                      type="text"
                      name="sub_title"
                      className="form-control store_input_field"
                      id="sub_title"
                      value={ADDEDITDATA?.sub_title}
                      onChange={handleChange}
                    />
                    {error.sub_title ? (
                      <p style={{ color: "red" }}>
                        {error.sub_title}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="content"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Content :{" "}
                    </label>
                    <textarea
                      title="Enter content"
                      placeholder="Enter content"
                      type="text"
                      name="content"
                      className="form-control store_input_field"
                      rows={5}
                      id="content"
                      value={ADDEDITDATA?.content}
                      onChange={handleChange}
                    />
                    {error.content ? (
                      <p style={{ color: "red" }}>
                        {error.content}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="btntext"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Button text :{" "}
                    </label>
                    <input
                      title="Enter button text"
                      placeholder="Enter button text"
                      type="text"
                      name="btntext"
                      className="form-control store_input_field"
                      id="btntext"
                      value={ADDEDITDATA?.btntext}
                      onChange={handleChange}
                    />
                    {error.btntext ? (
                      <p style={{ color: "red" }}>
                        {error.btntext}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="btnlink"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Button link :{" "}
                    </label>
                    <input
                      title="Enter button link"
                      placeholder="Enter button link"
                      type="text"
                      name="btnlink"
                      className="form-control store_input_field"
                      id="btnlink"
                      value={ADDEDITDATA?.btnlink}
                      onChange={handleChange}
                    />
                    {error.btnlink ? (
                      <p style={{ color: "red" }}>
                        {error.btnlink}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="form-group">
                  <label
                    htmlFor="exampleInputPassword1"
                    className="all_section_for_label_main_class"
                  >
                    {!ADDEDITDATA?._id && (
                      <span style={{ color: "red" }}>*</span>
                    )}
                    Images
                  </label>
                  <Dragger
                    className="about_us_dragger_file"
                    maxCount="5"
                    multiple={true}
                    listType="picture-card"
                    onChange={handleImageChange}
                    fileList={image}
                    beforeUpload={() => false} // Prevent automatic upload
                    onRemove={handleRemove} 
                  >
                    <button
                      type="button"
                      className="about_us_dragger_file_button"
                    >
                      Upload file
                    </button>
                  </Dragger>
                  <p
                    style={{ color: "blue" }}
                    className="all_top_and_bottom_for_input_text"
                  >
                    *Note: Please select an image format (JPG,JPEG,PNG) of dimension 362x452.
                  </p>
                  {error.image ? (
                    <p style={{ color: "red" }}>{error.image}</p>
                  ) : (
                    ""
                  )}
                </div>
                <div className="inventory_edit_submit_btn">
                  <button
                    type="button"
                    className="btn btn-primary inventory_save_button"
                    onClick={handleSubmit}
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <LoadingEffect isLoading={isLoading} />
    </div>
  );
};

export default UserListEditPage;
